
export default class ConversationRollbackEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

ConversationRollbackEvent.PERFORM = "ConversationRollbackEvent.PERFORM";